import type TagDto from "../../../../dto/construction/TagDto";
import React, {useState} from "react";
import {useAuth} from "../../../../services/auth/hooks/useAuth";
import styles from "./ConstructionNewTagControl.module.scss";
import {IconButton} from "@fluentui/react";
import {type ConstructionNewTagControlProps, type TagButtonProps} from "./ConstructionNewTagControlProps";
import ConstructionNewAddTagsDialog from "./ConstructionNewAddTagsDialog";
import ConstructionNewDeleteTagsDialog from "./ConstructionNewDeleteTagsDialog";

const ConstructionNewTagControl: React.FC<ConstructionNewTagControlProps> = ({constructionId, tags}) => {
  const {user} = useAuth();
  const isAllowedToTakeAction = user?.isAllowedToTakeAction();

  const [hideDeletionDialog, setHideDeletionDialog] = useState<boolean>(true);
  const [hideAdditionDialog, setHideAdditionDialog] = useState<boolean>(true);
  const [tagToDelete, setTagToDelete] = useState<string>();

  if (!isAllowedToTakeAction) {
    return null;
  }

  const handleRemoveTag = (tag: TagDto): void => {
    setTagToDelete(tag.value);
    setHideDeletionDialog(false);
  };

  const handleAddTag = (): void => {
    setHideAdditionDialog(false);
  };

  const handleAddDialogDismiss = (): void => {
    setHideAdditionDialog(true);
  };

  const handleDeleteDialogDismiss = (): void => {
    setHideDeletionDialog(true);
  };
  return (
    <>
      <ul className={styles.tagsContainer}>
        {tags?.map((tag, index) => {
          return (
            <li className={styles.tag} key={index}>
              <span className={styles.name}>{tag.value}</span>
              <span className={styles.removeBtn}>
                <RemoveTagButton
                  onClick={() => {
                    handleRemoveTag(tag);
                  }}
                />
              </span>
            </li>
          );
        })}
        <li key="add" className={`${styles.tag} ${styles.bordered}`}>
          <span className={styles.addBtn}>
            <AddTagButton
              onClick={() => {
                handleAddTag();
              }}
            />
          </span>
        </li>
      </ul>
      <ConstructionNewDeleteTagsDialog
        isHidden={hideDeletionDialog}
        handleDismiss={handleDeleteDialogDismiss}
        tag={tagToDelete}
        constructionId={constructionId}
      />
      <ConstructionNewAddTagsDialog isHidden={hideAdditionDialog} handleDismiss={handleAddDialogDismiss} />
    </>
  );
};

const AddTagButton: React.FC<TagButtonProps> = ({onClick}) => {
  const iconProps = {iconName: "Add"};
  const ADD_TAG_TITLE = "Add new tag";
  return <IconButton iconProps={iconProps} title={ADD_TAG_TITLE} ariaLabel={ADD_TAG_TITLE} onClick={onClick} />;
};

const RemoveTagButton: React.FC<TagButtonProps> = ({onClick}) => {
  const iconProps = {iconName: "Clear"};
  const REMOVE_TAG_TITLE = "Remove tag";
  return <IconButton iconProps={iconProps} title={REMOVE_TAG_TITLE} ariaLabel={REMOVE_TAG_TITLE} onClick={onClick} />;
};

export default ConstructionNewTagControl;
